module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_9_Clifford.1bacb0eb6b13560736698acaf1d0bef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_9_Clifford.png
// module id = 756
// module chunks = 0